<template>
    <v-container  v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading" >
            <v-layout row wrap align-center justify-space-between>
                <v-btn-toggle v-model="viewType" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'table'"><span class="long-button-text chamberButton">Table</span></v-btn>
                        </template>
                        <span>Table</span>
                    </v-tooltip>                    
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'timeline'"><span class="long-button-text chamberButton">Timeline</span></v-btn>
                        </template>
                        <span>Timeline</span>
                    </v-tooltip>
                </v-btn-toggle>              
            </v-layout>
            
            <v-layout row wrap v-if="viewType === 'table'">
                <v-flex xs12 md1 mt-4 mt-xs-2>
                    
                    <v-menu
                        ref="menuDate"                            
                        :close-on-content-click="false"                                                
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date"
                            label="Date"   
                            hint="YYYY-MM-DD"   
                            persistent-hint                                         
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                    
                </v-flex>  
            </v-layout>

            <br/>

            <v-menu v-if="this.isMobile" d-inline  :close-on-content-click="true">
                    <v-btn outline small slot="activator">
                        Sort <v-icon>sort</v-icon>
                    </v-btn>
                    <v-list>
                        <v-subheader>
                            Sort by:
                        </v-subheader>
                        <v-list-tile v-for="(item) in headers.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                            <v-list-tile-title>
                                {{ item.text }}
                                <v-icon v-if="pagination.sortBy === item.value">{{pagination.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
            </v-menu>
            <template v-if="viewType === 'table'">

            <div class="stats-table">
                <v-data-table
                    :headers="headers" 
                    :items="filteredItems"
                    :custom-sort="customSort"
                    item-key="$id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="ROWS_LISTITEMS" 
                    :hide-actions="true"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :hide-headers="isMobile"
                    :expand="true"
                    :loading="loading"
                    :disable-initial-sort="true">
                    <template v-slot:items="props">
                        <template v-if="isMobile">
                            <tr>
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3>{{ props.item.Name }}</h3>
                                        </div>
                                        <div class="flex-item">
                                            <div class="flex-item flex-item-col flex-item-col-60" data-label="Date Election">
                                            {{ props.item.DateElection | stringDateFormat }}
                                            </div>
                                            <div class="flex-item flex-item-col flex-item-col-40" data-label="Date Dissolution">
                                                <span v-if="props.item.DateDissolution != null">{{ props.item.DateDissolution | stringDateFormat }}</span>
                                                <span v-if="props.item.DateDissolution == null">N/A</span>
                                            </div>                                          
                                            <div v-for="(session, index) in props.item.Sessions" :key="session.$id">
                                                <div class="flex-item flex-item-col flex-item-col-60" style="vertical-align: top;">
                                                        <h4 class="pb-xs-1">{{ index + 1 | ordinal | capitaliseFirstLetter }} session</h4>
                                                    {{ session.DateOpening | stringDateFormat }}–{{ session.DateClosing | stringDateFormat }}
                                                </div>
                                                <div class="flex-item flex-item-col flex-item-col-40" data-label="Double Dissolution">
                                                    <span>{{ props.item.DoubleDissolution | isBoolean}}</span>                                                
                                                </div>                                                
                                                <div class="flex-item flex-item-col flex-item-col-40" v-if="session.Prorogations.length > 0" data-label="Prorogued">
                                                    <div v-for="prorogation in session.Prorogations" :key="prorogation.$id">
                                                        {{ prorogation.DateProrogued | stringDateFormat }} <sup>{{ prorogation | footnote }}</sup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="!isMobile">
                            <tr @click="props.expanded = !props.expanded">
                                <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                                <td class="text-xs-left"><strong>{{ props.item.Name }}</strong></td>
                                <td class="text-xs-left">{{ props.item.Sessions.length }}</td>
                                <td class="text-xs-left"><strong>{{ props.item.DateElection | stringDateFormat }}</strong></td>
                                <td class="text-xs-center">
                                    <a v-if="props.item.HorDissolvedProclamation" :href="props.item.HorDissolvedProclamation" target="_blank">{{ props.item.DateDissolution | stringDateFormat }}</a>
                                    <span v-else>{{ props.item.DateDissolution | stringDateFormat }}</span>
                                </td>
                                <td class="text-xs-center">{{ props.item.DoubleDissolution | isBoolean }}</td>
                            </tr>
                        </template>
                    </template>
                    <template v-slot:expand="props">   
                        <div class="pa-3">  
                        <v-data-table    
                            :headers="[              
                                { text: 'Session', value: '$id'},                                                                                  
                                { text: 'Opened', value: 'DateOpening'},
                                { text: 'Closed', value: 'DateClosing'},
                                { text: 'Prorogued', value: 'DateProrogued'}                                
                            ]"
                            :items="props.item.Sessions"                                
                            :hide-headers="isMobile"        
                            :hide-actions="true"
                            :disable-initial-sort="true"
                            :class="{ mobileDataTable: isMobile, 'elevation-1': true }">
                            <template v-slot:items="innerProps">
                                <tr>
                                    <td>{{ innerProps.index + 1 | ordinal | capitaliseFirstLetter }} session</td>                                    
                                    <td class="text-xs-left">{{ innerProps.item.DateOpening | stringDateFormat }}</td>
                                    <td class="text-xs-left">{{ innerProps.item.DateClosing | stringDateFormat }}</td>
                                    <td>
                                        <div v-for="prorogation in innerProps.item.Prorogations" :key="prorogation.$id">
                                            <a v-if="prorogation.ProrogationProclamation" :href="prorogation.ProrogationProclamation" target="_blank">{{ prorogation.DateProrogued | stringDateFormat }}</a> 
                                            <span v-else>{{ prorogation.DateProrogued | stringDateFormat }}</span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                <v-chip outline color="secondary" v-on="on" v-if="prorogation.ByGovernorGeneral 
                                            || prorogation.FurtherProrogation || prorogation.Reps || prorogation.Senate || prorogation.OneMinuteBefore" small>{{ prorogation | footnote }}</v-chip>
                                                </template>
                                                <span>{{ prorogation | explanation }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>                                    
                                </tr>
                            </template>
                        </v-data-table>
                        </div>
                    </template>
                    <template v-slot:footer>
                    </template>
                </v-data-table>
            </div>
            <br/>
    
            <v-layout row wrap>
                <v-flex xs12 sm8>
                    <div>* Parliament prorogued by Governor-General in an address to members of both Houses in the Senate Chamber.</div>
                    <div>† Parliament further prorogued</div>
                    <div>‡ House of Representatives</div>
                    <div>+ Senate</div>
                    <div>x Parliament was prorogued one minute before the House of Representatives was dissolved.</div>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>
            </template>

            <chronology-timeline :items="items" v-if="viewType === 'timeline'"></chronology-timeline>

             <br/>
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import ChronologyTimeline from './ChronologyTimeline.vue';
var converter = require('number-to-words');
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        ChronologyTimeline
    },
    mounted() {
        this.onResize();
    },
    filters: {
        ordinal: function(i) {
            return converter.toWordsOrdinal(i);
        },
        capitaliseFirstLetter: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        footnote: function (prorogation) {
            let footnote = '';
            if (prorogation.ByGovernorGeneral) {
                footnote += '*';
            }
            if (prorogation.FurtherProrogation) {
                footnote += '†';
            }
            if (prorogation.Reps) {
                footnote += '‡';
            }
            if (prorogation.Senate) {
                footnote += '+';
            }
            if (prorogation.OneMinuteBefore) {
                footnote += 'x';
            }
            return footnote;
        },
        explanation: function (prorogation) {
            let footnote = '';
            if (prorogation.ByGovernorGeneral) {
                footnote += 'Parliament prorogued by Governor-General in an address to members of both Houses in the Senate Chamber.';
            }
            if (prorogation.FurtherProrogation) {
                footnote += 'Parliament further prorogued';
            }
            if (prorogation.Reps) {
                footnote += 'House of Representatives';
            }
            if (prorogation.Senate) {
                footnote += 'Senate';
            }
            if (prorogation.OneMinuteBefore) {
                footnote += 'Parliament was prorogued one minute before the House of Representatives was dissolved.';
            }
            return footnote;            
        }
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } 
            else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        initialiseItems() {
            this.loading = true;
            const url = `StatisticalInformation/Parliaments`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        numberToOrdinal(number) {
            if (number <= 0) return number.toString();

            switch (number % 100) {
                case 11:
                case 12:
                case 13:
                    return number + "th";
            }

            switch (number % 10) {
                case 1:
                    return number + "st";
                case 2:
                    return number + "nd";
                case 3:
                    return number + "rd";
                default:
                    return number + "th";
            }
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === 'DateOpening') {
                        if (!isDesc) {
                            a.Sessions = a.Sessions.sort((c, d) => (c.DateOpening > d.DateOpening) ? 1 : -1)
                            b.Sessions = b.Sessions.sort((c, d) => (c.DateOpening > d.DateOpening) ? 1 : -1)
                            const aService = a.Sessions[0].DateOpening;
                            const bService = b.Sessions[0].DateOpening;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.Sessions = a.Sessions.sort((c, d) => (c.DateOpening < d.DateOpening) ? 1 : -1)
                            b.Sessions = b.Sessions.sort((c, d) => (c.DateOpening < d.DateOpening) ? 1 : -1)
                            const aService = a.Sessions[0].DateOpening;
                            const bService = b.Sessions[0].DateOpening;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'DateClosing') {
                        if (!isDesc) {
                            a.Sessions = a.Sessions.sort((c, d) => (c.DateClosing > d.DateClosing) ? 1 : -1)
                            b.Sessions = b.Sessions.sort((c, d) => (c.DateClosing > d.DateClosing) ? 1 : -1)
                            const aService = a.Sessions[0].DateClosing;
                            const bService = b.Sessions[0].DateClosing;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            return aService < bService ? -1 : 1;
                        } else {
                            a.Sessions = a.Sessions.sort((c, d) => (c.DateClosing < d.DateClosing) ? 1 : -1)
                            b.Sessions = b.Sessions.sort((c, d) => (c.DateClosing < d.DateClosing) ? 1 : -1)
                            const aService = a.Sessions[0].DateClosing;
                            const bService = b.Sessions[0].DateClosing;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'DateProrogued') {
                        if (!isDesc) {
                            const aService = a.Sessions[0].Prorogations.length > 0 ? a.Sessions[0].Prorogations[0].DateProrogued : null;
                            const bService = b.Sessions[0].Prorogations.length > 0 ? b.Sessions[0].Prorogations[0].DateProrogued : null;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            return aService < bService ? -1 : 1;
                        } else {
                            const aService = a.Sessions[0].Prorogations.length > 0 ? a.Sessions[0].Prorogations[0].DateProrogued : null;
                            const bService = b.Sessions[0].Prorogations.length > 0 ? b.Sessions[0].Prorogations[0].DateProrogued : null;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'Sessions') {
                        if (!isDesc) {
                            return a[index].length < b[index].length ? -1 : 1;
                        } else {
                            return b[index].length < a[index].length ? -1 : 1;
                        }
                    }
                    else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return b[index] < a[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },  
        exportCsv: function () {
            this.csvDownloading = true;
            const records = [];
            var getItems =  this.items.slice();
            getItems.forEach(i => {
                const parliament = { 
                    ['Parliament']: i.Name, 
                    ['Elected']: new Date(i.DateElection).toLocaleDateString(),
                    ['Dissolved']: i.DateDissolution && new Date(i.DateDissolution).toLocaleDateString(),
                    ['DoubleDissolution']: i.DoubleDissolution
                };
                records.push(parliament);
                i.Sessions.forEach((s, index) => {
                    const session = {
                        ['Session']: this.numberToOrdinal(index + 1) + " session", 
                        ['Opened']: s.DateOpening && new Date(s.DateOpening).toLocaleDateString(),
                        ['Closed']: s.DateClosing && new Date(s.DateClosing).toLocaleDateString(),
                        ['Prorogued']: s.Prorogations.length > 0 ? new Date(s.Prorogations.slice()[0].DateProrogued).toLocaleDateString() : null
                    }
                    records.push(session);
                    if (s.Prorogations.length > 1) {
                        const prorogations = s.Prorogations.slice().splice(1).map(p => ({
                            ['Prorogued']: new Date(p.DateProrogued).toLocaleDateString()
                        }));
                        records.push(prorogations);
                    }
                });
            });

            const filename = 'Chronology of Parliaments';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: this.csv_headers, FILENAME: filename, COMMENT: comment, STRICTHEADERS: true })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        }
    }, 
    computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            filteredItems() {
                return this.date ?
                this.items
                    .filter(i => this.date > i.DateElection && (i.DateDissolution === null || this.date < i.DateDissolution))
                    : this.items;
            }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
            date: null,
            isMobile: false,
            viewType: 'table',
            ROWS_LISTITEMS: [{
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            title: 'Chronology of Parliaments',
            headers: [
                { text: '', value: 'Number', sortable: false, width: '10px'},
                { text: 'Parliament', value: 'Number'},
                { text: 'Sessions', value: 'Sessions'},
                { text: 'Elected Date', value: 'DateElection'},
                { text: 'HoR Dissolution Date (link to Proclamation)', value: 'DateDissolution', align: 'center'},
                { text: 'Double Dissolution?', value: 'DoubleDissolution', align: 'center'}
            ],
            csv_headers: [
                { label: 'Parliament', value: 'Parliament'},
                { label: 'Session', value: 'Session'},
                { label: 'Elected', value: 'Elected'},
                { label: 'Dissolved (HoR)', value: 'Dissolved'},
                { label: 'Opened', value: 'Opened'},
                { label: 'Closed', value: 'Closed'},
                { label: 'Prorogued', value: 'Prorogued'},
                { text: 'Double Dissolution?', value: 'DoubleDissolution'}
            ],
            items: [],
            parties: [],
            partiesExcludingTotal: [],
            search: '',
            loading: true,
            csvDownloading: false,
            selectedMpOrSenator: ['senator', 'mp'],
            pagination: {
                rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                sortBy: 'Number',
                descending: true
            },
        }
    }
}
</script>
<style lang="stylus" scoped>
   @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }
</style>
